import { render } from "./ItemDialog.vue?vue&type=template&id=b8e1f904"
import script from "./ItemDialog.vue?vue&type=script&lang=js"
export * from "./ItemDialog.vue?vue&type=script&lang=js"

import "./ItemDialog.vue?vue&type=style&index=0&id=b8e1f904&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__